var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_40796",
    "data-name": "Group 40796",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 143.978,
    height: 143.978,
    viewBox: "0 0 143.978 143.978",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.03,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6713ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923cd5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M263.687,343.234a68.629,68.629,0,1,0,68.629,68.629A68.708,68.708,0,0,0,263.687,343.234Zm0,0",
    transform: "translate(-191.387 -339.508)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_206_-_Outline",
    "data-name": "Path 206 - Outline",
    d: "M266.3,486.462a71.989,71.989,0,1,1,71.989-71.989A72.07,72.07,0,0,1,266.3,486.462Zm0-137.258a65.269,65.269,0,1,0,65.269,65.269A65.342,65.342,0,0,0,266.3,349.2Z",
    transform: "translate(-194.309 -342.484)",
    fill: "rgba(207,137,255,0.44)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40797",
    "data-name": "Group 40797",
    transform: "translate(40.476 39.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11312",
    "data-name": "Path 11312",
    d: "M477.305,385.511l5.613-3.735c3.238-2.153,6.472-4.313,9.721-6.45a.882.882,0,0,0,.459-.943,11.677,11.677,0,1,1,2.521,6.595l-.3-.365c-.39.255-.772.5-1.15.753q-6.523,4.34-13.052,8.671a.757.757,0,0,0-.383,1.042,10.652,10.652,0,0,1-.017,6.513c-.1.33-.175.56.2.805q7.142,4.719,14.263,9.468a.671.671,0,0,0,.15.049c.373-.42.724-.875,1.135-1.269,3.416-3.273,7.442-4.385,11.953-2.933a11.178,11.178,0,0,1,8.034,9.379,11.774,11.774,0,1,1-23.331,3.159c-.087-.725,0-1.47-.037-2.2a.949.949,0,0,0-.291-.667q-7.628-5.109-15.283-10.179a1.958,1.958,0,0,0-.237-.117,11.919,11.919,0,0,1-16.73-.984,11.789,11.789,0,0,1-.041-15.583A11.925,11.925,0,0,1,477.305,385.511Z",
    transform: "translate(-457.58 -361.915)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBtn);
export default __webpack_public_path__ + "static/media/share-btn.1994e6b45f31597e79314b4cf194b2af.svg";
export { ForwardRef as ReactComponent };